<div class="relative flex min-h-screen w-full items-center justify-center bg-cover bg-center overflow-hidden" 
     style="background-image: url('assets/images/login_background.jpeg');">
  
  <div class="absolute inset-0 bg-black/40"></div>

  <div class="relative w-[90%] max-w-[400px] rounded-2xl border border-navy-cyan/40 bg-navy-dark/60 p-8 backdrop-blur-xl shadow-neon-border">
    
    <div class="absolute top-4 right-4 cursor-pointer text-white/60 hover:text-white transition-colors">
      <span class="text-2xl font-light">✕</span>
    </div>

    <div class="flex flex-col items-center mb-10">
      <div class="relative group">
        <div class="absolute inset-0 scale-125 bg-navy-cyan/20 blur-2xl rounded-full"></div>
        <img src="assets/images/navy_logo.png" class="relative w-28 h-28 object-contain" alt="Navy Logo" />
      </div>
      <h2 class="mt-4 text-3xl font-semibold tracking-[0.15em] text-white italic drop-shadow-md">
        IIMA Login
      </h2>
    </div>

  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-5">
  
  <div class="relative">
    <div class="absolute left-4 top-1/2 -translate-y-1/2 text-white z-10">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    </div>
    <input 
      type="text" 
      formControlName="loginname"
      placeholder="Login ID"
      autocomplete="off"
      class="autofill-fix w-full rounded-xl border border-[#00f2ff]/50 bg-transparent py-2.5 pl-12 pr-4 text-white placeholder-white/60 outline-none transition-all focus:border-[#00f2ff] focus:ring-1 focus:ring-[#00f2ff]/30"
    />
  </div>

  <div class="relative">
    <div class="absolute left-4 top-1/2 -translate-y-1/2 text-white">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
      </svg>
    </div>
    <input 
      [type]="showPassword ? 'text' : 'password'" 
      formControlName="password"
      placeholder="Password"
      autocomplete="new-password"
      class="autofill-fix w-full rounded-xl border border-[#00f2ff]/50 bg-transparent py-2.5 pl-12 pr-12 text-white placeholder-white/60 outline-none transition-all focus:border-[#00f2ff]"
    />
    <button 
      type="button"
      (click)="toggleShowPassword()"
      class="absolute right-4 top-1/2 -translate-y-1/2 text-white/60 hover:text-white">
      <span class="text-lg">{{ showPassword ? '👁️' : '🔒' }}</span>
    </button>
  </div>
    
   

  <div class="relative pt-2">
    <div class="absolute -top-0.5 left-1/4 h-[2px] w-1/2 bg-navy-cyan shadow-[0_0_10px_#00f2ff]"></div>
    <div class="absolute -bottom-0.5 left-1/4 h-[2px] w-1/2 bg-navy-cyan shadow-[0_0_10px_#00f2ff]"></div>
    
    <button 
      type="submit" 
      class="w-full rounded-lg border-2 border-navy-cyan bg-transparent py-2.5 text-xl font-black tracking-widest text-white uppercase italic transition-all hover:bg-navy-cyan/10">
      LOGIN
    </button>
  </div>
</form>
  </div>
</div>